import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * config/live, the public config functions write from their env
 * (docs/booking-contracts.md section 10): the open-time grid, the booking
 * lead time and the dev switch. It is the app's one source for the slot
 * size: nothing assumes half hours for open or proposed times.
 */
export interface LiveConfig {
  /** Minutes between open times: 10 on staging, 30 in production. */
  slotMinutes: number;
  minLeadMinutes: number;
  /** DEV ONLY: LIVE_DEV_ANY_TIME. Draw the whole grid from now on. */
  devAnyTime: boolean;
}

/** The live config, or null until it has loaded (or for a signed-out reader). */
export function useLiveConfig(): LiveConfig | null {
  const [config, setConfig] = useState<LiveConfig | null>(null);
  useEffect(() => onSnapshot(doc(db, 'config', 'live'), (snap) => {
    const d = snap.data();
    setConfig(d && typeof d.slotMinutes === 'number'
      ? { slotMinutes: d.slotMinutes, minLeadMinutes: Number(d.minLeadMinutes) || 0, devAnyTime: d.devAnyTime === true }
      : null);
  }, () => setConfig(null)), []);
  return config;
}
